import { render, staticRenderFns } from "./purchase-order-summary.vue?vue&type=template&id=bb400f5e&"
import script from "./purchase-order-summary.vue?vue&type=script&lang=js&"
export * from "./purchase-order-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports